import React from 'react'
import { MdArrowForward } from 'react-icons/md'

import { Box, Flex, Heading, Link, Text } from '../system'
import ImagePlaceholder from '../placeholder'

const BlogCard = ({ ...props }) => (
  <Box
    {...props}
    minWidth="16rem"
    maxWidth="30rem"
    borderRadius={1}
    boxShadow={0}
  >
    <ImagePlaceholder aspectRatio={1 / 2} mb={2} />
    <Box p={{ xxs: 4, md: 5, lg: 6 }}>
      <Heading fontSize={{ xxs: 4, md: 5, lg: 7 }} fontWeight={1}>
        Using decoupled Drupal with Gatsby with Kyle Mathews
      </Heading>

      <Flex alignItems="center" my={3}>
        <Box
          width={28}
          height={28}
          flex="0 0 auto"
          bg="grey.100"
          borderRadius={6}
          mr={2}
        />
        <Text color="grey.500" fontSize={1}>
          <Link href="#" css={{ textDecoration: 'none' }}>
            Shannon Soper
          </Link>{' '}
          on August 13th 2018
        </Text>
      </Flex>

      <Text fontSize={2} my={6}>
        <strong>Why use Drupal + Gatsby together?</strong> Kyle Mathews is
        presenting on “Gatsby + Drupal” at Decoupled Drupal Days NYC this
        Saturday; for those who can’t make it to his presentation, we wanted to
        give you a sneak peak of what it will be about.
      </Text>

      <Flex mt={4} alignItems="center">
        <Link href="#" css={{ textDecoration: 'none' }}>
          Read more <MdArrowForward style={{ verticalAlign: 'middle' }} />
        </Link>
      </Flex>
    </Box>
  </Box>
)

export default BlogCard
